<template>
  <el-dialog :title="form.id?'编辑':'新建'" :visible.sync="formVisible" width="800px" :close-on-click-modal="false">
    <el-form ref="dataForm" :rules="formRules" :model="form" label-position="right" size="small" label-width="100px">
      <el-form-item label="商户号" prop="cusId">
        <el-input v-model="form.cusId" placeholder="请输入商户号" />
      </el-form-item>
      <el-form-item label="机构号" prop="orgId">
        <el-input v-model="form.orgId" placeholder="请输入机构号" />
      </el-form-item>
      <el-form-item label="应用ID" prop="appId">
        <el-input v-model="form.appId" placeholder="请输入应用ID" />
      </el-form-item>
      <el-form-item label="版本号" prop="version">
        <el-input v-model="form.version" placeholder="请输入版本号" />
      </el-form-item>
      <el-form-item label="公钥" prop="pubKey">
        <el-input v-model="form.pubKey" placeholder="请输入公钥" />
      </el-form-item>
      <el-form-item label="私钥" prop="privateKey">
        <el-input v-model="form.privateKey" placeholder="请输入私钥" />
      </el-form-item>
      <el-form-item label="状态" prop="state">
        <el-switch v-model="form.state" :active-value="1" :inactive-value="0"></el-switch>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="formVisible = false">取消</el-button>
      <el-button type="primary" @click="doCreate()">确认</el-button>
    </div>
  </el-dialog>
</template>

<script>
import yongyouConfigApi from '@/api/config/yongyouConfig'
function initFormBean() {
  const formBean = {
    cusId: null,
    orgId: '56366705137XAWM',
    appId: '00326724',
    version: '12',
    pubKey: 'MFkwEwYHKoZIzj0CAQYIKoEcz1UBgi0DQgAEGAX9T0owMEoE5qV1qMt96EmYJp35RsciyPG',
    privateKey: 'MIGTAgEAMBMGByqGSM49AgEGCCqBHM9VAYItBHkwdwIBAQQgNBkZ3uVWnlD2fEOJ8xoEOrTlhGI6pm6v9fuV1iGFnDWgCgYIKoEcz1UBgi2hRANCAAQYBf1PSjAwSgTmpXWoy33oSZgmnflGxyLI8b5SqDHCHO20IWRH0tV17IqgVMPDWRBlULg9KQsQ8eFwIl4Ukt4G',
    state: 1,
  }
  return formBean
}

export default {
  props: ['yongyouConfigId'],
  data() {
    return {
      old: initFormBean(),
      form: initFormBean(),
      formVisible: false,
      formRules: {
        cusId: [{ required: true, message: '请输入商户号', trigger: 'blur' }],
        orgId: [{ required: true, message: '请输入机构号', trigger: 'blur' }],
        appId: [{ required: true, message: '请输入应用ID', trigger: 'blur' }],
        version: [{ required: true, message: '请输入版本号', trigger: 'blur' }],
        pubKey: [{ required: true, message: '请输入公钥', trigger: 'blur' }],
        privateKey: [{ required: true, message: '请输入私钥', trigger: 'blur' }],
        state: [{ required: true, message: '请选择状态', trigger: 'change' }],
      }
    }
  },
  created() {

  },
  methods: {
    /**
     * 重置表单
     */
    resetForm() {
      for (const key in initFormBean()) {
        this.form[key] = this.old[key]
      }
    },
    /**
     * 打开新建表单
     */
    handleCreate(total) {
      this.old = initFormBean();
      this.form = initFormBean();
      this.formVisible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate()
      })
    },
    handleUpdate(row) {
      this.old = { ...row }
      this.resetForm()
      this.form.id = row.id
      this.formVisible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate()
      })
    },
    /**
     * 执行新建操作
     */
    doCreate() {
      let params = JSON.parse(JSON.stringify(this.form))
      params.yongyouConfigId = this.yongyouConfigId
      this.$refs["dataForm"].validate((valid) => {
        if (valid) {
          yongyouConfigApi.addOrUpdateConfigPay(params).then((data) => {
            this.postCallback(data)
          });
        }
      });
    },
    postCallback(response) {
      this.$message.success('操作成功')
      this.formVisible = false;
      this.$emit('created')
    },
  }
}
</script>
<style lang="scss" scoped>
::v-deep .el-select {
  width: 100%;
}
.el-form-item--small.el-form-item {
  width: 48%;
  display: inline-block;
  vertical-align: top;
}
.el-form-item--small.el-form-item.width100 {
  width: 97%;
}
</style>
